import {
  Button,
  ButtonGroup,
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  useMediaQuery
} from "@material-ui/core";
import { UploadButtonInput } from "components/UploadButtonInput";
import { theme } from "config/theme";
import useText from "constants/text";
import { NewJobContext } from "domains/Job/context";
import { ArrowDropDownIcon } from "icons";
import React from "react";
import { actionStyles } from "./style";

export interface Action {
  key: string;
  label: string;
  type?: string;
  accept?: string;
}

export interface ActionsGroupProps {
  actions: Array<Action>;
  onClick: (key: string, data?: any) => void;
  buttonName: string;
  onChange?: (data: any, loaderFunc: any) => void;
  padding?: any;
  className?: string;
  isParcel?: boolean;
}
const ActionsGroup: React.FC<ActionsGroupProps> = ({
  actions,
  onClick,
  buttonName = "",
  onChange,
  padding,
  className,
  isParcel,
}): React.ReactElement => {
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const [open, setOpen] = React.useState(false);
  const ref = React.useRef(null);
  const jobContext = React.useContext(NewJobContext);
  const styles = actionStyles({ buttonName });
  const { text } = useText();

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClick = (key: string) => {
    onClick(key);
    setOpen(false);
  };

  const handleClose = (event: React.MouseEvent<Document, MouseEvent>) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return;
    }
    setOpen(false);
  };

  const isSmallScreen = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <>
      <ButtonGroup
        className={styles.buttonGroup}
        variant="contained"
        color="primary"
        ref={anchorRef}
        aria-label="split button"
      >
        <Button
          className={styles.buttonName}
          onClick={handleToggle}
          style={{
            width: isParcel ? "160px" : "210px",
            left: isParcel ? "-5px" : "-4px",
            alignItems: "center"
          }}
        >
          {buttonName}
        </Button>
        {!jobContext && (
          <Button
            style={{ width: "50px", background: "red" }}
            color="primary"
            size="small"
            aria-controls={open ? "split-button-menu" : undefined}
            aria-expanded={open ? "true" : undefined}
            aria-label="select merge strategy"
            aria-haspopup="menu"
            onClick={handleToggle}
          >
            <ArrowDropDownIcon color="#fff" />
          </Button>
        )}
      </ButtonGroup>
      <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition ref={ref}>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper className={styles.paper}>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  id="split-button-menu"
                  className={styles.menuList}
                  style={{
                    width:
                      (isParcel && isSmallScreen && "161px") ||
                      (isParcel && !isSmallScreen && "160px") ||
                      (!isParcel && isSmallScreen && "210px"),
                    marginLeft: (isParcel && isSmallScreen && -10) || (isParcel && !isSmallScreen && -8),
                  }}
                >
                  {actions.map((action) => (
                    <MenuItem
                      style={{ padding: 5, width: jobContext ? "auto" : "200px", fontSize: "12.70px" }}
                      key={action.key}
                      onClick={() => handleClick(action.key)}
                    >
                      {action.type !== "input" ? (
                        action.label
                      ) : (
                        <UploadButtonInput accept={action.accept} onChangeInput={onChange} style={{ width: "200px" }} />
                      )}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};

export default ActionsGroup;
